var swiper = new Swiper(".al-swiper", {
  slidesPerView: 1.5,
  spaceBetween: 8,
  centeredSlides: true,
  loop: true,
  initialSlide: 2,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    768: {
      slidesPerView: 2,
      spaceBetween: 48,
    },
    991: {
      slidesPerView: 3,
      spaceBetween: 48,
    },
  },
});
